import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, Contact } from '../api';
import { ErrorBox, useAsync } from '../components/ui';
import { ContactForm, ContactInput } from './ContactForm';

export function ContactsPage() {
  const [q, setQ] = useState('');
  const [data, setData] = useState<{ items: Contact[]; total: number } | null>(null);
  const [creating, setCreating] = useState(false);
  const list = useAsync();
  const create = useAsync();
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => list.run(async () => setData(await api(`/contacts?query=${encodeURIComponent(q)}&limit=100`))), 200);
    return () => clearTimeout(t);
  }, [q]);
  const submit = async (v: ContactInput) => {
    const c = await create.run(() => api<Contact>('/contacts', { method: 'POST', body: v }));
    if (c) nav(`/kontaktok/${c.id}`);
  };
  return (
    <div>
      <div className="page-head">
        <h2>Kontaktok</h2>
        <input className="search" placeholder="Keresés név, e-mail vagy cég szerint…" value={q} onChange={(e) => setQ(e.target.value)} />
        <button onClick={() => setCreating(true)}>Új kontakt</button>
      </div>
      {creating && <section className="card"><h3>Új kontakt</h3><ContactForm onSubmit={submit} onCancel={() => setCreating(false)} error={create.error} busy={create.busy} /></section>}
      <ErrorBox error={list.error} />
      <table className="list">
        <thead><tr><th>Név</th><th>Cég</th><th>Pozíció</th><th>E-mail</th><th>Telefon</th></tr></thead>
        <tbody>
          {data?.items.map((k) => (
            <tr key={k.id} onClick={() => nav(`/kontaktok/${k.id}`)}>
              <td><Link to={`/kontaktok/${k.id}`}>{k.full_name}</Link></td>
              <td>{k.company_name ?? '–'}</td><td>{k.position ?? '–'}</td><td>{k.email ?? '–'}</td><td>{k.phone ?? '–'}</td>
            </tr>
          ))}
          {data && data.items.length === 0 && <tr><td colSpan={5} className="muted">Nincs találat.</td></tr>}
        </tbody>
      </table>
      {data && data.total > data.items.length && <p className="muted">{data.items.length} / {data.total} látszik – szűkítsd a keresést.</p>}
    </div>
  );
}
